module.exports = __webpack_public_path__ + "static/media/turntable.2e2dab78.svg";